import { cancelOrder, setPolicyAgree } from '../../../actions';
import { identityPayload, createReducer, forAction } from '../../../utils';

const initialState = false;

export default createReducer(
  [forAction(setPolicyAgree, identityPayload)],
  initialState,
  [cancelOrder],
);
